import React from 'react';
import HeaderComponent from '../header/header.component';
import BodyComponent from '../body/body.component';
import FooterComponent from '../footer/footer.component';
import { RouteProps } from 'react-router';

interface IProps {
    children: RouteProps['children'];
    component: any;
}

class MainLayoutComponent extends React.Component<IProps> {
    // eslint-disable-next-line
    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                {/* main app container */}
                <HeaderComponent />
                <div className="container">
                    <BodyComponent component={this.props.children} />
                </div>
                <FooterComponent />
            </React.Fragment>
        );
    }
}

export default MainLayoutComponent;
